module.exports = __webpack_public_path__ + "img/sld_cs_2_og.6ed358ed.svg";